export enum InventoryTypes {
	Item = 'Item',
	Component = 'Component',
}
